
import * as types from '../types'
import * as userApi from '../../api/core/user.dd'
import { store } from '../store';

const state = {
  isAuthenticated:  !!localStorage.getItem("access_token"),
  token: localStorage.getItem("access_token"),
  user: JSON.parse(localStorage.getItem("currentUser")),
  languages: [
    {code: 'nl', 'label': 'global.DUTCH', 'locale': 'nl'},
    {code: 'en', 'label': 'global.ENGLISH', 'locale': 'en-gb'}
  ],
  selectedLanguage: null,
  allUsers: [],
  allUsersMeta: {pagination:{}},
  allUserRoles:[],
  allUserRolePermissions:[],
  allUserRolePermissionsMeta: {pagination:{}},
  userFavoriteAssets: [],
  userFavoriteAssetsMeta: {pagination:{}},
  userFavoriteAssetGroups:[],
  userFavoriteAssetGroupsMeta:{pagination:{}},
  selectedUser: null,
  usersOnline: []
}

const getters = {
  [types.IS_AUTHENTICATED]: (state) => {
    return state.isAuthenticated
  },
  [types.USERS_ONLINE]: (state) => {
    return state.usersOnline
  },
  [types.USER_ACCESS_TOKEN]: (state) => {
    return state.token
  },
  [types.USER_FAVORITE_ASSETS]: (state) => {
    return state.userFavoriteAssets
  },  
  [types.USER_FAVORITE_ASSETS_META]: (state) => {
    return state.userFavoriteAssetsMeta
  },
  [types.USER_FAVORITE_ASSET_GROUPS]: (state) => {
    return state.userFavoriteAssetGroups
  },  
  [types.USER_FAVORITE_ASSET_GROUPS_META]: (state) => {
    return state.userFavoriteAssetGroupsMeta
  },
  [types.CURRENT_USER]: (state) => {
    return state.user
  },
  [types.USER_LANGUAGE]: (state) => {
    return state.selectedLanguage
  },
  [types.LANGUAGES]: (state) => {
    return state.languages
  },
  [types.USERS]: (state) => {
    return state.allUsers
  },
  [types.USER]: (state) => {
    return state.selectedUser
  },
  [types.USERS_META]: (state) => {
    return state.allUsersMeta
  },  
  [types.USERS_PAGINATION]: (state) => {
    return state.allUsersMeta.pagination
  },
  [types.USER_ROLES]: (state) => {
    return state.allUserRoles
  },  
  [types.USER_ROLE_PERMISSIONS_META]: (state) => {
    return state.allUserRolePermissionsMeta
  },  
  [types.USER_ROLE_PERMISSIONS_PAGINATION]: (state) => {
    return state.allUserRolePermissionsMeta.pagination
  },  
  [types.USER_ROLE_PERMISSIONS]: (state) => {
    return state.allUserRolePermissions
  }    
}

const mutations = {
  [types.LOGIN_SUCCESS]: (state, payload) =>{
    state.isAuthenticated = true
  },
  [types.USER_FAVORITE_ASSETS]: (state, payload) =>{
    state.userFavoriteAssets     = payload.data
    state.userFavoriteAssetsMeta = payload.meta
  },  
  [types.USER_FAVORITE_ASSETS_META]: (state, payload) => {
    state.userFavoriteAssetsMeta = payload
  },
  [types.USER_FAVORITE_ASSET_GROUPS]: (state, payload) =>{
    state.userFavoriteAssetGroups = payload.data
    state.userFavoriteAssetGroupsMeta = payload.meta
  },  
  [types.USER_FAVORITE_ASSET_GROUPS_META]: (state, payload) => {
    state.userFavoriteAssetGroupsMeta = payload
  },
  [types.USER]: (state, payload) =>{
    state.selectedUser = payload
  },  
  [types.USERS_ONLINE]: (state, payload) =>{
    state.usersOnline = payload
  },  
  [types.CURRENT_USER]: (state, payload) =>{
 
    state.user = payload
    localStorage.setItem("currentUser", JSON.stringify(payload));
    localStorage.setItem("lastUser", payload.email);
  },
  [types.LOGOUT]: (state, payload) => {
    state.user = false
    state.token = ''
    state.isAuthenticated = false
    localStorage.removeItem('token')
  },
  [types.USER_LANGUAGE]: (state, payload) => {
    state.selectedLanguage = payload
  },
  [types.USERS]: (state, payload) => {
    state.allUsers = payload.data
    state.allUsersMeta = payload.meta
  },
  [types.USER_ROLES]: (state, payload) => {
    state.allUserRoles = payload.data
  },  
  [types.USER_ROLE_PERMISSIONS]: (state, payload) => {
    state.allUserRolePermissions = payload.data
    state.allUserRolePermissionsMeta = payload.meta
  },
  [types.USER_ACCESS_TOKEN]: (state, payload) => {
    localStorage.setItem("access_token", payload);
    state.token = payload
  }
}

const actions = {
  [types.USER_LANGUAGE]: ({ commit }, payload) => {
    commit(types.USER_LANGUAGE, payload)
  },
  [types.USERS_ONLINE]: ({ commit }, payload) => {
    commit(types.USERS_ONLINE, payload)
  },
  [types.USER_FAVORITE_ASSETS]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          userApi.allUserFavoriteAssets(payload.data, payload.params).then( (res) => {
              commit(types.USER_FAVORITE_ASSETS, res)
              resolve(res)
          }).catch((e) => {
            reject(e)
          })
      })
      return p
  },
  [types.SAVE_USER_FAVORITE_ASSET]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
      userApi.saveUserFavoriteAsset(payload.data).then( (res) => {
          resolve(res.data)
      }).catch((e) => {
          reject(e)
      }) 
    })
    return p
  },  
  [types.USER_FAVORITE_ASSET_GROUPS]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        userApi.allUserFavoriteAssetGroups(payload.data, payload.params).then( (res) => {
            commit(types.USER_FAVORITE_ASSET_GROUPS, res)
            resolve(res)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
  },     
  [types.SAVE_USER_FAVORITE_ASSET_GROUP]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
      userApi.saveUserFavoriteAssetGroup(payload.data).then( (res) => {
          resolve(res.data)
      }).catch((e) => {
          reject(e)
      }) 
    })
    return p
  }, 
  [types.SAVE_ASSET_GROUPS_ON_ROLE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
      userApi.saveAssetGroupOnRole(payload).then( (res) => {
          resolve(res.data)
      }).catch((e) => {
          reject(e)
      }) 
    })
    return p
  },   
  [types.USER_LOGIN]: ({ commit }, payload) => {

    let p = new Promise((resolve, reject) => {
        userApi.login(payload).then((res) => {

          commit(types.USER_ACCESS_TOKEN, res.access_token)
                              
          // when successfully logged in trigger the CURRENT_USER action to load current user
          store.dispatch(types.LOAD_CURRENT_USER).then((res) => {                                                                           
             commit(types.LOGIN_SUCCESS, {...payload, ...res})
             resolve(res.data)                
          }).catch((e) => { // could not retrieve current user
            reject(e)
          })

        }).catch((e) => { // could not log in
          reject(e.data)
        })
    })
    return p
  },
  [types.LOAD_CURRENT_USER]: ({ commit }, payload) => {

    let p = new Promise((resolve, reject) => {
                    
        // when successfully logged in trigger the CURRENT_USER action to load current user
        store.dispatch(types.CURRENT_USER,{ params:{ include:"person,person.address,avatar,tenant,availableTenants,permissions,roles"}}).then((res) => {                                                                   
          store.dispatch(types.USER_FAVORITE_ASSETS,{data:{"userId":res.id },params:{per_page:200, include:"asset"}})
          // Caution! This returns the result of login!              
            resolve(res)                
        }).catch((e) => { // could not retrieve current user
          
          // also remove token if current user can't be retrieved
          commit(types.USER_ACCESS_TOKEN, null)
          reject(e)
        })
    })
    return p
  },
  [types.USER]: ({ commit }, payload) => {
    if(payload){
      let p = new Promise((resolve, reject) => {
          userApi.getUser(payload.data, payload.params).then( (res) => {
              commit(types.USER, res.data)
              resolve(res.data)
          }).catch((e) => {
            reject(e.data)
          })
      })
      return p
    }
    else{
      commit(types.USER, null)
    }
  },
  [types.USERS]: ({ commit }, payload) => {

    let p = new Promise((resolve, reject) => {
        userApi.allUsers(payload.params).then( (res) => {
            commit(types.USERS, res)
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })
    })
    return p
  },
  [types.USER_ROLE_PERMISSIONS]: ({ commit }, payload) => {

    let p = new Promise((resolve, reject) => {
        userApi.allUserRolePermissions(payload.params).then( (res) => {
            commit(types.USER_ROLE_PERMISSIONS, res)
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })
    })
    return p
  },  

  [types.USER_ROLE_PERMISSIONS_SEARCH]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        userApi.searchUserRolePermissions(payload.data, payload.params).then((res) => {
            commit(types.USER_ROLE_PERMISSIONS, res)
            resolve()
        }).catch((e) => {
          reject(e.data)
        })
    })
    return p
  },  
  [types.SYNC_USER_ROLE_PERMISSIONS]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        userApi.syncUserRolePermissions(payload).then( (res) => {
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })
    })
    return p
  },    

  [types.USER_ROLES]: ({ commit }, payload) => {

    let p = new Promise((resolve, reject) => {
        userApi.allUserRoles(payload.params).then( (res) => {
            commit(types.USER_ROLES, res)
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })
    })
    return p
  },
  [types.SYNC_USER_ROLES]: ({ commit }, payload) => {
      
    let p = new Promise((resolve, reject) => {
        userApi.syncUserRoles(payload).then( (res) => {
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })
    })
    return p
  },
  [types.USERS_SEARCH]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        userApi.searchUsers(payload.data, payload.params).then((res) => {
            commit(types.USERS, res)
            resolve()
        }).catch((e) => {
          reject(e.data)
        })
    })
    return p
  },
  [types.SAVE_USER]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {

        userApi.saveUser(payload.data, {}).then( (res) => {
            resolve(res)
        }).catch((e) => {          
          reject(e.error)
        })        
    })
    return p
  },
  [types.USER_SWITCH_TENANT]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {
        userApi.userSwitchTenant(payload.data, {}).then((res) => {
            resolve(res)
        }).catch((e) => {          
          reject(e.error)
        })        
    })
    return p
  },  
  [types.SAVE_USER_ROLE]: ({ commit }, payload) => {
    let p = new Promise((resolve, reject) => {

        userApi.saveUserRole(payload.data, {}).then( (res) => {
            resolve(res)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },  
  [types.USER_REQUEST_RESET_PASSWORD]: ({ commit }, payload) => {   

    let p = new Promise((resolve, reject) => {
        userApi.getPasswordResetRequest(payload, {}).then( (res) => {
          
            resolve(res)
        }).catch((e) => {
          reject(e)
        })        
    })
    return p
  },  
  [types.USER_RESET_PASSWORD]: ({ commit }, payload) => {   
     
    let p = new Promise((resolve, reject) => {
        userApi.resetUserPassword(payload, {}).then( (res) => {
            resolve(res.data)
        }).catch((e) => {
          reject(e)
        })        
    })
    return p
  },  
  [types.USER_RESET_PASSWORD_TOKEN]: ({ commit }, data) => {   
    let p = new Promise((resolve, reject) => {
        userApi.getPasswordChangeToken(data, {}).then( (res) => {
            resolve(res.data)
        }).catch((e) => {
          reject(e.data)
        })        
    })
    return p
  },
  [types.CURRENT_USER]: ({ commit }, payload) => {        
    let p = new Promise((resolve, reject) => {
        userApi.currentUser(payload.params).then((res) => {            
            commit(types.CURRENT_USER, res.data)
            resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
    })
    return p
  },
  logout: ( {commit}, payload) => {
    commit(types.LOGOUT,payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
